import React from "react";
import { Button } from "@mui/material";

import { DELETE_BUTTON } from "store/constant";

const HDCommandButton = ({
  commandButtonName,
  disableDelete,
  onHandleCommand,
}) => {
  return (
    <>
      <Button
        size="medium"
        type="submit"
        variant="contained"
        disabled={disableDelete}
        onClick={onHandleCommand}
        disableElevation
      >
        {commandButtonName || DELETE_BUTTON}
      </Button>
    </>
  );
};

export default HDCommandButton;
